import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-waiting-button',
  templateUrl: './waiting-button.component.html',
  styleUrls: ['./waiting-button.component.scss', '../base-button.scss'],
})
export class WaitingButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
